export const columnData = {
  Code: { name: 'Código', widthCol: '5%' },
  Month: { name: 'Mes', widthCol: '10%' },
  Year: { name: 'Año', widthCol: '10%' },
  TotalAmount: { name: 'Montos totales', widthCol: '30%' },
  Status: { name: 'Estado', widthCol: '15%' },
  Description: { name: 'Descripción', widthCol: '30%' }
}
